
import {
    onMounted,
    ref,
    defineAsyncComponent,
} from 'vue'; 

import numeral from 'numeral';

import useProductos from '@/modules/ventas/composables/useProductos';

export default {
    components: {
        ProductoEditarComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/ProductoEditarComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerProductos,
        } = useProductos();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'Código de barras', value: 'codigo_barras', sortable: true },
            { text: 'Nombre', value: 'nombre', sortable: true },
            { text: 'Categoría', value: 'nombre_categoria', sortable: true },
            { text: 'Marca', value: 'nombre_marca', sortable: true },
            { text: 'Presentación', value: 'nombre_presentacion', sortable: true },
            { text: 'Estado', value: 'estado', sortable: true },
            { text: '', value: 'acciones', width: 15 },
        ];

        let productos: any = [];
        const productosFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const productoEditarComponentRef = ref();

        onMounted(async() => {
            await buscarProductos();
        });

        const buscarProductos = async () => {
            const resp = await obtenerProductos(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                productos = resp.data;
                productosFiltrados.value = JSON.parse(JSON.stringify(productos));
            }
        }

        const nuevoProducto = async () => {
            productoEditarComponentRef.value.abrirComponent();
        }

        const editarProducto = async (producto: any) => {
            productoEditarComponentRef.value.abrirComponent(JSON.parse(JSON.stringify(producto)));
        }

        const filtrarInformacion = async () => {
            productosFiltrados.value = JSON.parse(JSON.stringify(
                productos.filter(
                    (u: any) => u.codigo_barras.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nombre.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nombre_categoria.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nombre_marca.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nombre_presentacion.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarEditarProductoComponentEmit = async(seGrabo: boolean) => {
            if (seGrabo) {
                await buscarProductos();
            }
        }

        return {
            fitroBusqueda,
            headers,
            textoFiltro,
            productosFiltrados,

            buscarProductos,
            editarProducto,
            filtrarInformacion,
            nuevoProducto,

            numeral,

            productoEditarComponentRef,
            cerrarEditarProductoComponentEmit,
        };
    }
}
